import type { ArchetypeId } from '../engine/archetype';

export const ARCHETYPE_COPY: Record<ArchetypeId, { title: string; body: string }> = {
  'paper-strong-person-weak': {
    title: 'Paper-strong, person-weak',
    body:
      'You have the scaffolding, but your directors are not yet equipped to use it. The fastest uplift is targeted board literacy, not more policy work.',
  },
  'smart-but-unstructured': {
    title: 'Smart but unstructured',
    body:
      'Your directors are sharp, but the governance scaffolding is not there. The fastest uplift is putting structure around the conversations you are already having.',
  },
  'mature-board-ready': {
    title: 'Mature, board-ready',
    body:
      'You are operating at the level the new ISO/IEC 42001 standard and the APRA letter both implicitly demand. Most Australian SMB boards are not here yet.',
  },
  'developing-balanced': {
    title: 'Developing and balanced',
    body:
      'You are competent on both governance and director capability, without a glaring weakness on either side. The work now is lifting both from solid to board-ready, against the bar ISO/IEC 42001 and the APRA guidance now set. A quarterly board AI review keeps it on track.',
  },
  'at-foundation': {
    title: 'At foundation',
    body:
      'Both axes need work in parallel. Start with the AI Charter, because it forces the strategy conversation that makes everything else downstream possible.',
  },
};

export const BAND_TONE: Record<string, 'danger' | 'warning' | 'success'> = {
  'at-risk': 'danger',
  maturing: 'warning',
  mature: 'success',
};
